module.exports = __webpack_public_path__ + "img/ContentCutOutlined.02d568ae.svg";